<div id="orders" class="page-layout carded fullwidth">
    <div class="top-bg primary"></div>
    <!-- CENTER -->
    <div class="center" fusePerfectScrollbar>

        <!-- HEADER -->
        <div class="header primary" fxLayout="column" fxLayoutAlign="center center" fxLayout.gt-xs="row"
            fxLayoutAlign.gt-xs="space-between center">

            <!-- APP TITLE -->
            <div class="mat-display-1 my-0 my-sm-24 welcome-message" fxLayout="row" fxLayoutAlign="start center">
                <span [@animate]="{value:'*',params:{delay:'100ms',x:'-25px'}}">{{'SIMULATION' | translate}}</span>
            </div>
            <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="center center" >
                <div class="speed-time-select">
                    <mat-form-field appearance="outline">
                        <mat-select placeholder="{{'SPEED_TIME'|translate}}" [(ngModel)]="speedTime" name="speedTime">
                            <mat-option [value]="250">
                                {{'VERY_FAST'|translate}}
                            </mat-option>
                            <mat-option [value]="500">
                                {{'FAST'|translate}}
                            </mat-option>
                            <mat-option [value]="1000">
                                {{'NORMAL_FAST'|translate}}
                            </mat-option>
                            <mat-option [value]="2000">
                                {{'SLOW'|translate}}
                            </mat-option>
                            <mat-option [value]="4000">
                                {{'VERY_SLOW'|translate}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <button mat-raised-button (click)="onSimulationClick()">
                    <mat-icon>{{this.simulation?'pause':'play_arrow'}}</mat-icon>
                    {{this.simulation?("STOP"|translate):("START"|translate)}}</button>
            </div>

            <!-- / APP TITLE -->
        </div>
        <!-- / HEADER -->
        <div *ngIf="selectCarControl!=null" [hidden]="car == null" class="content-card  my-20">
            <div class="map-container">
                <div class="map-frame">
                    <div id="map">
                        <div mat-dialog-actions align="end">

                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="selectCarControl==null" class="content-card my-20">
            <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="10px" style="height: 100%;">
                <div class="w-30-p">
                    <h3>{{'SELECT_CAR'|translate}}</h3>
                </div>
                <mat-form-field appearance="outline" floatLabel="always" class="w-30-p">
                    <mat-label>{{'SELECT_CAR'|translate}}</mat-label>
                    <mat-select [(ngModel)]="selectCar" required name="companies">
                        <mat-option *ngFor="let item of cars" [value]="item">
                            {{item.plate}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <div class="w-30-p" fxLayout="row" fxLayoutAlign="space-between center">
                    <button mat-raised-button type="button" (click)="ngAfterViewInit()">{{'APPROVE'|translate}}</button>
                </div>
            </div>
        </div>
        <div>
        </div>
    </div>
    <!-- / CENTER -->
</div>